import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Label, ModalBody, ModalFooter } from "reactstrap";
import { object, string } from "yup";
import ToastHandler from "../../../components/Common/ToastHandler";
import Axios from "../../../lib/Axios";
import useInterestGroupStore from "../../../zStore/interestGroupStore";
import useInterestListStore from "../../../zStore/interestListStore";

const schema = object({
  groupId: string().required("Required"),
  interestsId: string().required("Required"),
});

const InterestGroupAssociationForm = ({ data, setEditData, refetch }) => {
  const [toast, setToast] = useState(false);

  const [toastData, setToastData] = useState({
    title: "",
    message: "",
  });

  const { groupInterestSelectCompatiable } = useInterestGroupStore();
  const { interestListSelectCompatiable } = useInterestListStore();

  async function onSubmit(formData) {
    try {
      const dt = data
        ? {
            ...formData,
            groupInterestsId: data.groupInterestsId,
          }
        : {
            ...formData,
          };

      const result = data
        ? await Axios.post("/cms/cms-edit/interest-group-association", dt)
        : await Axios.post("/cms/cms-set/interest-group-association", dt);

      setToastData({
        message: "Submitted",
        title: "Success",
      });
      setToast(true);
      refetch();
    } catch (error) {
      if (error.status === 500) {
        setToastData({
          message: error.response.data.error.message,
          title: "Error",
        });
        setToast(true);
      } else if (error.status === 400) {
        setToastData({
          message: error.response.data.message,
          title: "Error",
        });
        setToast(true);
      }
    }
  }

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      groupId: data ? data?.groupId : "",
      interestsId: data ? data?.interestsId : "",
      // companyName: data ? data?.companyName : "",
    },
    validationSchema: schema,
    onSubmit: onSubmit,
  });

  useEffect(() => {
    return () => {
      if (data) {
        setEditData(null);
      }
    };
  }, []);

  return (
    <>
      {/* {JSON.stringify(data)} */}
      <form className="tablelist-form" onSubmit={formik.handleSubmit}>
        <ModalBody>
          <div className="mb-3">
            <Label>Group Interest</Label>

            <Select
              defaultValue={
                data && {
                  label: data.InterestGroupName.groupName,
                  value: data.InterestGroupName.groupId,
                }
              }
              isSearchable={true}
              onChange={(e) => {
                formik.setFieldValue("groupId", e.value);
              }}
              name="color"
              options={groupInterestSelectCompatiable}
            />
            {formik.touched.groupId && formik.errors.groupId && (
              <div className="error">{formik.errors.groupId}</div>
            )}
            <div className="my-2"></div>
            <Label>Interest</Label>

            <Select
              defaultValue={
                data && {
                  label: data.Interest.interestName,
                  value: data.Interest.interestId,
                }
              }
              isSearchable={true}
              onChange={(e) => {
                formik.setFieldValue("interestsId", e.value);
              }}
              name="color"
              options={interestListSelectCompatiable}
            />
            {formik.touched.interestsId && formik.errors.interestsId && (
              <div className="error">{formik.errors.interestsId}</div>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="hstack gap-2 justify-content-end">
            {/* <button
            type="button"
            className="btn btn-light"
            // onClick={() => setmodal_list(false)}
          >
            Close
          </button> */}
            <button
              disabled={formik.isSubmitting}
              type="submit"
              className="btn btn-success"
            >
              {formik.isSubmitting ? "Wait..." : "Submit"}
            </button>
          </div>
        </ModalFooter>
      </form>
      <ToastHandler
        open={toast}
        setOpen={setToast}
        duration={2000}
        message={toastData.message}
        title={toastData.title}
      />
    </>
  );
};

export default InterestGroupAssociationForm;
